import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

const EditDialog = ({ visible, onHide, onSubmit, loading, tariff }) => {
    const [marginPrice, setMarginPrice] = React.useState(0);
    const [insPrice, setInsPrice] = React.useState(0);

    React.useEffect(() => {
        if (visible && tariff) {
            setMarginPrice(tariff.marginPrice ?? 0);
            setInsPrice(tariff.insPrice ?? 0);
        }
    }, [visible, tariff]);

    const handleSave = () => {
        if (marginPrice < 0 || insPrice < 0) return;
        onSubmit({ marginPrice, insPrice });
    };

    const footer = (
        <div>
            <Button label="Отмена" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Сохранить" icon="pi pi-check" loading={loading} onClick={handleSave} />
        </div>
    );

    if (!tariff) return null;

    return (
        <Dialog header={`Редактировать тариф #${tariff.id}`} visible={visible}
                style={{ width: "500px" }} modal onHide={onHide} footer={footer}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12">
                    <label>Платформа</label>
                    <InputText value={tariff.platform || ""} disabled />
                </div>
                <div className="p-field p-col-12">
                    <label>Клиент</label>
                    <InputText value={tariff.clientName || ""} disabled />
                </div>
                <div className="p-field p-col-12">
                    <label>Тип отправления</label>
                    <InputText value={tariff.postalType || ""} disabled />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Маржа</label>
                    <InputNumber value={marginPrice} mode="decimal" minFractionDigits={2} min={0}
                                 onValueChange={e => setMarginPrice(e.value ?? 0)} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Страховка</label>
                    <InputNumber value={insPrice} mode="decimal" minFractionDigits={2} min={0}
                                 onValueChange={e => setInsPrice(e.value ?? 0)} />
                </div>
            </div>
        </Dialog>
    );
};

export default EditDialog;
